export default __webpack_public_path__ + "static/034-058798c13d873e65bc8a548e2a8e2281.png";